'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _toArray2 = require('babel-runtime/helpers/toArray');

var _toArray3 = _interopRequireDefault(_toArray2);

exports.isEqual = isEqual;
exports.isNotEqual = isNotEqual;
exports.parseLocationParams = parseLocationParams;
exports.isDestinationNotEqual = isDestinationNotEqual;
exports.getIds = getIds;
exports.convertStayToCheckinAndCheckout = convertStayToCheckinAndCheckout;
exports.convertCheckinAndCheckoutToStay = convertCheckinAndCheckoutToStay;
exports.convertLocationToState = convertLocationToState;
exports.convertStateToLocationQuery = convertStateToLocationQuery;
exports.convertSearchStateToForm = convertSearchStateToForm;
exports.convertFormToSearchState = convertFormToSearchState;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _filters = require('./filters');

var _destinationParser = require('./destination-parser');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// query is the location.query object
// states is the search state
// since currency the query param is not in the location.query,
// so when comparing the two objects the currency param is ignored
function isEqual(query, states) {
  return _lodash2.default.isEqual(_lodash2.default.omitBy(query, function (val) {
    return val === '' || val === undefined || val === null;
  }), _lodash2.default.omitBy(states, function (val, key) {
    return val === '' || val === undefined || val === null || key === 'currency' || key === 'errors';
  }));
}

function isNotEqual(query, states) {
  return !isEqual(query, states);
}

function parseLocationParams(params) {
  if (params.areaID) {
    var _params$areaID$split = params.areaID.split('-'),
        _params$areaID$split2 = (0, _toArray3.default)(_params$areaID$split),
        country = _params$areaID$split2[0],
        subdivision = _params$areaID$split2[1],
        city = _params$areaID$split2[2],
        spotParts = _params$areaID$split2.slice(3);

    var spot = spotParts.join('-');

    return {
      country: country.replace(/_/g, ' '),
      // XXX: keep the _ for _Prefecture temporarily
      subdivision: subdivision,
      city: city ? city.replace(/_/g, ' ') : '',
      // XXX: actually when hotelID is available, spot is hotel name
      spot: params.hotelID ? '' : spot ? spot.replace(/_/g, ' ') : '',
      hotel: params.hotelID
    };
  }

  return {
    country: params.countryID ? params.countryID.replace(/_/g, ' ') : '',
    // XXX: keep the _ for _Prefecture temporarily
    subdivision: params.subdivisionID,
    city: params.cityID ? params.cityID.replace(/_/g, ' ') : '',
    spot: params.spotID ? params.spotID.replace(/_/g, ' ') : '',
    hotel: params.hotelID
  };
}

function isDestinationNotEqual(params, search) {
  var _parseLocationParams = parseLocationParams(params),
      country = _parseLocationParams.country,
      subdivision = _parseLocationParams.subdivision,
      city = _parseLocationParams.city,
      spot = _parseLocationParams.spot;

  var locationParams = { country: country, subdivision: subdivision, city: city, spot: spot };
  var searchStateParams = {
    country: search.country,
    subdivision: search.subdivision,
    city: search.city,
    spot: search.spot
  };

  return isNotEqual(locationParams, searchStateParams);
}

function getIds(params) {
  var _parseLocationParams2 = parseLocationParams(params),
      country = _parseLocationParams2.country,
      subdivision = _parseLocationParams2.subdivision,
      city = _parseLocationParams2.city,
      spot = _parseLocationParams2.spot,
      hotel = _parseLocationParams2.hotel;

  if (params.hotelID) {
    return hotel;
  }

  return [country, subdivision, city, spot].filter(function (area) {
    return area;
  }).join(',');
}

function convertStayToCheckinAndCheckout() {
  var stay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  var arr = stay.match(/\[(.*),(.*)\]/);
  return arr ? { checkin: arr[1], checkout: arr[2] } : { checkin: null, checkout: null };
}

function convertCheckinAndCheckoutToStay(_ref) {
  var checkin = _ref.checkin,
      checkout = _ref.checkout;

  var checkinStr = checkin || '';
  var checkoutStr = checkout || '';
  return checkin || checkout ? '[' + checkinStr + ',' + checkoutStr + ']' : '';
}

function convertLocationToState(query, params) {
  var _parseLocationParams3 = parseLocationParams(params),
      country = _parseLocationParams3.country,
      subdivision = _parseLocationParams3.subdivision,
      city = _parseLocationParams3.city,
      spot = _parseLocationParams3.spot;

  var search = {
    offset: query.offset,
    limit: query.limit,
    stay: convertCheckinAndCheckoutToStay({
      checkin: query.checkin || query.checkin_date,
      checkout: query.checkout || query.checkout_date
    }) || '',
    // number of rooms
    rooms: query.rooms,
    adults: query.adults,
    children: query.children,
    age: query.age ? query.age : query.c_ages ? query.c_ages.join(',') : undefined,
    bed: query.bed ? query.bed : query.c_beds ? query.c_beds.join(',') : undefined,
    country: country,
    subdivision: subdivision,
    city: city,
    spot: spot,
    // room ID
    room: query.room || query.id_room,
    // plan ID
    plan: query.plan || query.id_plan,
    rate: query.rate || '',
    latlng: query.latlng || '',
    radius: query.radius || '',
    price: query.price || '',
    meals: query.meals || '',
    orderBy: query.orderBy || '',
    hotelFacility: query.hotelFacility || '',
    roomFacility: query.roomFacility || ''
  };

  // TODO: perhaps it'd be better to convert to the filters state as well
  // const filters = convertToStates();

  return {
    search: _lodash2.default.omitBy(search, function (val) {
      return val === undefined || val === null;
    })
  };
}

// filters argument is optional
function convertStateToLocationQuery(_ref2) {
  var search = _ref2.search,
      _ref2$filters = _ref2.filters,
      filters = _ref2$filters === undefined ? { filters: [], priceRange: {} } : _ref2$filters;

  var query = (0, _extends3.default)({
    offset: search.offset,
    limit: search.limit,
    rooms: search.rooms,
    adults: search.adults,
    children: search.children,
    age: search.age,
    bed: search.bed,
    rate: search.rate,
    latlng: search.latlng,
    radius: search.radius,
    price: search.price,
    meals: search.meals,
    orderBy: search.orderBy,
    hotelFacility: search.hotelFacility,
    roomFacility: search.roomFacility
  }, convertStayToCheckinAndCheckout(search.stay), _lodash2.default.omitBy((0, _filters.convertToParams)(filters), function (val) {
    return val === '' || val === undefined || val === null;
  }));

  return _lodash2.default.omitBy(query, function (val) {
    return val === '' || val === undefined || val === null;
  });
}

function convertSearchStateToForm(search) {
  var _convertStayToCheckin = convertStayToCheckinAndCheckout(search.stay),
      checkin = _convertStayToCheckin.checkin,
      checkout = _convertStayToCheckin.checkout;

  var children = Number(search.children);
  var childrenOptions = [];
  if (children) {
    var childCount = 0;
    var age = search.age.split(',');
    var bed = search.bed.split(',');
    while (childCount < search.children) {
      childrenOptions.push({
        age: age[childCount],
        bed: bed[childCount]
      });
      childCount += 1;
    }
  }

  return {
    destination: (0, _destinationParser.convertSearchStateToDestinationString)(search),
    checkin: checkin,
    checkout: checkout,
    adults: search.adults,
    rooms: search.rooms,
    children: search.children,
    childrenOptions: childrenOptions
  };
}

function convertFormToSearchState(values) {
  return (0, _extends3.default)({}, (0, _destinationParser.parse)((0, _destinationParser.hyphenize)(values.destination)), {
    stay: convertCheckinAndCheckoutToStay(values),
    rooms: values.rooms,
    adults: values.adults,
    children: values.children,
    age: values.childrenOptions.map(function (item) {
      return item.age;
    }).join(','),
    bed: values.childrenOptions.map(function (item) {
      return item.bed;
    }).join(',')
  });
}


//////////////////
// WEBPACK FOOTER
// ./src/helpers/query.js
// module id = 76
// module chunks = 0